import find from "lodash/find";
import get from "lodash/get";

import { SET_CURSOR_PREVIOUS } from "../types";
import { QUESTION_NOT_FOUND } from "../userErrors";
import addUserError from "./addUserError";

function setCursorPrevious(blocks, questions, payload, params) {
  return {
    blocks,
    questions,
    payload,
    params,
    type: SET_CURSOR_PREVIOUS
  };
}

export default function (blocks, questions, payload, current, getState) {
  const question = find(questions, { name: current });

  if (!question) {
    return dispatch => {
      dispatch(addUserError(QUESTION_NOT_FOUND, current));
    };
  }

  // Retrieve query parameters passed by user
  const params = get(getState(), 'params', {});

  // Go to next question in flow taking into account parameters passed
  const blockDisplayLogic = get(params, 'blockDisplayLogic', true);
  const questionDisplayLogic = get(params, 'questionDisplayLogic', true);
  return dispatch => dispatch(setCursorPrevious(blocks, questions, payload, { blockDisplayLogic, questionDisplayLogic }));
}
